import { Attribute } from "@/models/api/Attributes";
import { Expose, Type } from "class-transformer";
import { IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";

export class BookingItemDetails {
  @IsNumber()
  @Expose()
  id!: number;
  @IsNumber()
  @Expose()
  ordinal!: number;
  @IsOptional()
  @IsString()
  @Expose()
  sequenceNumber!: string;
  @IsOptional()
  @IsNumber()
  @Expose()
  bookingDataId!: number;
  @Type(() => Attribute)
  @ValidateNested()
  @Expose()
  attributes!: Array<Attribute>;
}

export type BookingDetails = Array<BookingItemDetails>;
